import React, { useEffect, useState } from "react";
import { Checkbox, Button, Grid, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, } from "@material-ui/core";
import { DeletePopUp, PageLoader, STableLoader, Pagination, EmptyCollection, ExportMenu, FilterComponent, RevisionHistory } from "../../../shared_elements";
import { useSnackbar } from "notistack";
import { trackActivity } from "../../../../utils/mixpanel";
import { globalDeleteService, globalExportService, globalGetService, globalPutService } from "../../../../globalServices";
import AddIcon from '@material-ui/icons/Add';
import { checkApiStatus,checkPermission } from "../../../utils_v2";
import CategoriesList from "../components/CategoriesList";
import AddEditCategories from "../components/AddEditCategories";
import { usePageTitleOffset } from '../../../elements/CollapsibleSideNav';

const CategoriesObj = {
    name: null,
    remarks: null,
}

const CategoriesHeader = ({ handleSelectAll, isSelectAllChecked, createSortHandler, sortInfo }) => {
    return (
        <TableHead>
            <TableRow >
                <TableCell style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex: 10, }} >{checkPermission('config_data', 'maintenance_program', 'D') &&<Checkbox checked={isSelectAllChecked} onChange={handleSelectAll} color="primary" size="small" />}Action(s)</TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'name' ? true : false}
                        direction={sortInfo.sort === 'name' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('name')}
                    >
                        Name
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'created_by' ? true : false}
                        direction={sortInfo.sort === 'created_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('created_by')}
                    >
                        Created By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'updated_by' ? true : false}
                        direction={sortInfo.sort === 'updated_by' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('updated_by')}
                    >
                        Last Updated By
                    </TableSortLabel>
                </TableCell>
                <TableCell >
                    <TableSortLabel
                        active={sortInfo.sort === 'remarks' ? true : false}
                        direction={sortInfo.sort === 'remarks' ? sortInfo.sort_by : 'asc'}
                        onClick={() => createSortHandler('remarks')}
                    >
                        Remarks
                    </TableSortLabel>
                </TableCell>
            </TableRow>
        </TableHead>
    )
}

const Categories = () => {
    const navTitleOffset = usePageTitleOffset('configDataNavCollapsed');

    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [isLoading, setLoading] = useState(false);
    const [filter, setFilter] = useState({});
    const [pageSelections, setPageSelections] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [skeletonLoader, setSkeletonLoader] = useState(false);
    const [sortInfo, setSortInfo] = useState({ sort: '', sort_by: '' });
    const [bulkDelete, setBulkDelete] = useState({ modal: false, data: null })
    const [bulkRevert, setBulkRevert] = useState({ modal: false, data: null })
    const [addEditCategories, setAddEditCategories] = useState({ modal: false, data: null });
    const [deleteCategories, setDeleteCategories] = useState({ modal: false, data: null });
    const [revertCategories, setRevertCategories] = useState({ modal: false, data: null });
    const [categoriesInfo, setCategoriesInfo] = useState({ list: [], pagination: {} });

    useEffect(() => {
        getCategory({ per_page: 50 }, "skeletonLoader");
        trackActivity('Console Management', { page_title: 'Config Data : Categories', event_type: 'Page Visited' })
    }, [])


    const getCategory = (query = {}, loaderType) => {
        loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true)
        globalGetService(`config-data/categories/`, query)
            .then(response => {
                if (checkApiStatus(response)) {
                    setCategoriesInfo(response.data.data)
                    if(query){
                        delete query.page
                        delete query.per_page
                        delete query.sort
                        delete query.sort_by
                        setFilter(query)
                    }
                }
                loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false)
            })
    }

    const onDelete = () => {
        setLoading(true);
        const ids = !deleteCategories.data ? Object.values(pageSelections).flat().filter(id => {
            const item = categoriesInfo.list.find(item => item.id === id);
            return item && !item.deleted_at;
        }) : deleteCategories.data.id

        globalDeleteService(`config-data/categories/bulk-delete/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setDeleteCategories({ modal: false, data: null });
                    getCategory({ ...filter, page: categoriesInfo?.pagination?.page, per_page: categoriesInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Categories',
                        event_type: `Item Deleted`,
                        event_desc: 'Categories Deleted Successfully',
                        success_msg: response?.data?.message,
                        deleted_id: ids
                    });
                } else {
                    setDeleteCategories({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkDelete({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Categories',
                        event_type: `Item Deleted`,
                        event_desc: 'Categories Deletion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };

    const onRevert = () => {
        setLoading(true);
        const ids = !revertCategories.data ? Object.values(pageSelections).flat().filter(id => {
            const item = categoriesInfo.list.find(item => item.id === id);
            return item && item.deleted_at;
        }) : revertCategories.data;

        globalPutService(`config-data/categories/restore/`, { ids })
            .then(response => {
                if (checkApiStatus(response)) {
                    setRevertCategories({ modal: false, data: null });
                    getCategory({ ...filter, page: categoriesInfo?.pagination?.page, per_page: categoriesInfo?.pagination?.per_page }, 'pageLoader');
                    setCurrentPage({});
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Categories',
                        event_type: `Item Reverted`,
                        event_desc: 'Categories Reverted Successfully',
                        success_msg: response?.data?.message,
                        reverted_id: ids
                    });
                } else {
                    setRevertCategories({ modal: false, data: null });
                    setLoading(false);
                    setPageSelections({});
                    setBulkRevert({ modal: false, data: null })
                    enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                    trackActivity('Console Management', {
                        page_title: 'Config Data : Categories',
                        event_type: `Item Reverted`,
                        event_desc: 'Categories Reversion Failed',
                        error_msg: response?.data?.message,
                        item_id: ids
                    });
                }
            });
    };


    const toggleBulkOps = (item, checked, currentPage) => {
        setPageSelections(prevSelections => {
            const updatedSelections = { ...prevSelections };
            if (checked) {
                updatedSelections[currentPage] = updatedSelections[currentPage] || [];
                updatedSelections[currentPage].push(item?.id);
            } else {
                updatedSelections[currentPage] = updatedSelections[currentPage]?.filter(id => id !== item?.id);
            }
            return updatedSelections;
        });
    };

    const handleSelectAll = (event, currentPage) => {
        if (event?.target.checked) {
            const allIds = categoriesInfo?.list.map(item => item.id);
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: allIds }));
        } else {
            setPageSelections(prevSelections => ({ ...prevSelections, [currentPage]: [] }));
        }
    };

    const getFilteredSelectionCounts = () => {
        let deleteCount = 0;
        let revertCount = 0;

        if (pageSelections[currentPage]?.length) {
            pageSelections[currentPage].forEach(id => {
                const selectedItem = categoriesInfo?.list?.find(item => item?.id === id);
                if (selectedItem) {
                    if (selectedItem?.deleted_at) {
                        revertCount++;
                    } else {
                        deleteCount++;
                    }
                }
            });
        }
        return { deleteCount, revertCount };
    };
    
    const { deleteCount, revertCount } = getFilteredSelectionCounts();

    const createSortHandler = (key) => {
        let sortQuery = { sort: key };
        if (sortInfo.sort === key) {
            sortQuery = { ...sortQuery, sort_by: sortInfo.sort_by === 'asc' ? 'desc' : 'asc' }
        } else {
            sortQuery = { ...sortQuery, sort_by: 'asc' }
        }
        setSortInfo(sortQuery)
        getCategory({ ...filter, ...sortQuery, page: 1, per_page: categoriesInfo?.pagination?.per_page || 20 }, 'pageLoader');
    }

    const isSelectAllChecked = categoriesInfo?.list?.length > 0 && pageSelections[currentPage]?.length === categoriesInfo?.list?.length;

    const getConfirmColor = () => {
        if (revertCategories?.modal || bulkRevert?.modal) return "primary";
        if (deleteCategories?.modal || bulkDelete?.modal) return "secondary";
        return "";
    };

    const getConfirmText = () => {
        if (revertCategories?.modal || bulkRevert?.modal) return "Revert";
        if (deleteCategories?.modal || bulkDelete?.modal) return "DELETE";
        return "";
    };

    const getModal = () => {
        if (revertCategories?.modal) return revertCategories.modal;
        if (deleteCategories?.modal) return deleteCategories.modal;
        if (bulkDelete?.modal) return bulkDelete.modal;
        if (bulkRevert?.modal) return bulkRevert.modal;
        return null;
    };

    const getTitle = () => {
        if (revertCategories?.modal) return "Revert Categories";
        if (deleteCategories?.modal) return "Delete Categories";
        if (bulkDelete?.modal) return `Delete Categories (${deleteCount})`;
        if (bulkRevert?.modal) return `Revert Categories (${revertCount})`;
        return "";
    };

    const getContent = () => {
        if (revertCategories?.modal || bulkRevert?.modal)
            return "Are you sure, you want to Revert?";
        if (deleteCategories?.modal || bulkDelete?.modal)
            return "Are you sure, you want to Delete?";
        return "";
    };

    const toggleModalFn = () => {
        if (revertCategories?.modal) {
            setRevertCategories({ modal: false, data: null });
        } else if (deleteCategories?.modal) {
            setDeleteCategories({ modal: false, data: null });
        } else if (bulkDelete?.modal) {
            setBulkDelete({ modal: false, data: null });
        } else {
            setBulkRevert({ modal: false, data: null });
        } 
    };


    const getDeleteRecordFn = () => {
        if (revertCategories?.modal || bulkRevert?.modal) return onRevert;
        if (deleteCategories?.modal || bulkDelete?.modal) return onDelete;
        return null;
    };

    const filterOption = (
		{
			'name': {
				'inputType': 'text',
				'title': 'Name',
			},
		})

    return (
        <>
            {skeletonLoader ? <STableLoader count={6} /> :
                <div style={{ paddingTop: '10px' }}>
                    <Paper elevation={0} className="console-paper" style={{ padding: '4px 8px', marginBottom: "2px" }}>
                        <Grid container spacing={1} alignItems="center">
                            <Grid item md={6}>
                                    <FilterComponent
                                        filter={filter}
                                        filterMenu={filterOption}
                                        getResponseBack={(applyFilter) => {getCategory ({ ...applyFilter, page: 1, per_page: categoriesInfo?.pagination?.per_page || 10 }, 'pageLoader') }}
                                    />
                            </Grid>
                            <Grid item md={6}>
                                <ul className='list-inline flex-centered' style={{ float: 'right' }}>
                                    {revertCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkRevert({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Categories', item_type: 'Bulk Revert', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Revert Modal from Categories` }) }} color="primary" size='small' variant="outlined">
                                                Revert ({revertCount})
                                            </Button>
                                        </li>
                                    )}
                                    {deleteCount > 0 && (
                                        <li className='list-inline-item'>
                                            <Button onClick={() => { setBulkDelete({ modal: true, data: null }); trackActivity('Console Management', { page_title: 'Config Data : Categories', item_type: 'Bulk Delete', event_type: 'Modal Clicked', event_desc: `Clicked to open Bulk Delete Modal from Categories` }) }} color="secondary" size='small' variant="contained">
                                                Delete ({deleteCount})
                                            </Button>
                                        </li>
                                    )}
                                    {checkPermission('config_data', 'maintenance_program', 'C') &&   <li className='list-inline-item'>
                                        <Button onClick={() => setAddEditCategories({ modal: true, data: CategoriesObj, type: 'add' })} color="primary" size='small' variant="contained"><AddIcon style={{ fontSize: '1.15rem' }} />ADD</Button>
                                    </li>}
                                    <li className='list-inline-item' style={{ cursor: 'pointer' }}>
                                        <RevisionHistory isExp={false} buttonType={true} url={`audit/config-data/cdcategoriesmaintenanceprograms/`} queryParams={{ action: '0,1,2' }} />
                                    </li>
                                </ul>
                            </Grid>
                        </Grid>
                    </Paper>
                    <Paper square>
                      <div style={{ height: `${(!categoriesInfo?.list?.length ? window.innerHeight - 200 : window.innerHeight - 250) - navTitleOffset}px`, overflow: 'auto' }}>
                        <Table className="mui-table-format" stickyHeader>
                            <CategoriesHeader isSelectAllChecked={isSelectAllChecked} handleSelectAll={(e) => handleSelectAll(e, currentPage)} createSortHandler={createSortHandler} sortInfo={sortInfo} />
                            <TableBody>
                                {categoriesInfo?.list?.length > 0 && categoriesInfo?.list?.map((item, index) =>
                                    <CategoriesList
                                        item={item}
                                        index={index}
                                        onDelete={setDeleteCategories}
                                        onRevert={setRevertCategories}
                                        onEditFn={() => setAddEditCategories({ modal: true, data: item, type: 'edit' })}
                                        onViewFn={() => setAddEditCategories({ modal: true, data: item, type: 'view' })}
                                        toggleBulkOps={(item, checked) => toggleBulkOps(item, checked, currentPage)}
                                        bulkIds={pageSelections[currentPage] || []}
                                    />
                                )}
                            </TableBody>
                         </Table>
                         {!categoriesInfo?.list?.length ? <div style={{ textAlign: 'center' }}><EmptyCollection title='No records found' /></div> : null}
                        </div>
                    </Paper>
                    <Paper square>
                        <Pagination
                            pagination={categoriesInfo?.pagination}
                            onChangePage={(event, newPage) => { getCategory({ ...filter, page: newPage + 1, per_page: categoriesInfo.pagination?.per_page, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader'); setCurrentPage(newPage + 1) }}
                            onChangeRowsPerPage={(event) => getCategory({ ...filter, page: 1, per_page: event.target.value, sort_by: sortInfo?.sort_by, sort: sortInfo?.sort }, 'pageLoader')}
                        />
                    </Paper>
                </div>}
            {addEditCategories.modal ?
                <AddEditCategories
                    addEditCategories={addEditCategories}
                    categoriesInfo={categoriesInfo}
                    toggleModalFn={() => setAddEditCategories({ modal: false, categoriesData: [] })}
                    getResponseBack={() => getCategory({ ...filter, page: categoriesInfo?.pagination?.page, per_page: categoriesInfo?.pagination?.per_page }, 'pageLoader')}
                    modeType={addEditCategories?.type}
                /> : null
            }
            <DeletePopUp
                confirmColor={getConfirmColor()}
                confirmText={getConfirmText()}
                modal={getModal()}
                title={getTitle()}
                content={getContent()}
                toggleModalFn={toggleModalFn}
                deleteRecordFn={getDeleteRecordFn()}
            />
            {isLoading ? <PageLoader /> : null}
        </>
    )

}
export default Categories;